import { motion } from 'framer-motion';
import { SectionHeading, ImageTag } from './SectionHeading';
import { HERO_PHOTO, PROGRESS_GRID, PROGRESS_VIDEO, fadeIn } from './data';

export const ProgressSection = () => (
  <section id="gallery" className="py-20 md:py-24 bg-[#1a1e1a]" data-testid="progress-section">
    <SectionHeading eyebrow="Gallery">The Home Today</SectionHeading>
    <div className="max-w-6xl mx-auto px-6 md:px-12">
      <motion.div {...fadeIn} className="relative overflow-hidden mb-3">
        <img src={HERO_PHOTO} alt="The 126 House — exterior landscape view" className="block w-full h-auto" data-testid="current-progress-image" />
        <ImageTag>Actual photography</ImageTag>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3">
        {PROGRESS_GRID.map((p) => (
          <motion.div
            key={p.src}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="relative overflow-hidden aspect-[16/9]"
          >
            <img src={p.src} alt={p.alt} className="w-full h-full object-cover" />
            <ImageTag>Actual photography</ImageTag>
          </motion.div>
        ))}
      </div>

      <motion.div {...fadeIn} className="relative bg-black mt-3">
        <video src={PROGRESS_VIDEO} autoPlay muted loop playsInline controls preload="metadata" data-testid="progress-video" className="w-full h-auto" />
        <ImageTag>Site flyover</ImageTag>
      </motion.div>
    </div>
  </section>
);
